<script setup>

const props = defineProps({
  ann:{
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  editing: {
    type: Boolean,
    default: false
  },
  isMenu: {
    type: Boolean,
    default: false
  },
  isEnd: {
    type: Boolean,
    default: false
  }
})
import { AnnStore } from '@/front/stores/ann_store.js';
const annStore = AnnStore();

import { PositionCalculator } from '@/front/composables/PositionCalculator.js';
const { calculatePosition } = PositionCalculator()

const customStyle = props.ann.customStyle && JSON.parse(props.ann.customStyle) || {}
const styling = computed(() => {
  const dimensions = calculatePosition(props.ann)
  let opacity = props.disabled ? 0.5 : 1
  let cursor = props.disabled ? 'not-allowed' : 'pointer'
  let base = {
    'width': props.editing ? '100%' : `${dimensions.width}px`,
    'height': props.editing ? '100%' : `${dimensions.height}px`,
    'left': `${dimensions.left}px`,
    'top': `${dimensions.top}px`,
    'minHeight': `${dimensions.minHeight}px`,
    'fontSize': `${dimensions.fontSize}px`,
    'minHeight': '',
    'padding': 0,
    'opacity': opacity,
    'cursor': cursor,
  }
  let caption = {
    'color': props.ann.text_color || customStyle.text_color,
  }
  return {
    base,
    caption,
  }
})
import { cdnImageUrl } from '@/front/composables/ImageComposer.js'

const isNoneClickAction = computed(() => {
  return props.ann.click_action == 'none'
})

const getImageClassList = computed(() => {
  return {
    'spotlightMode': props.ann.do_spotlight,
    'spotlightDim': annStore.spotlightInteraction && annStore.spotlightInteraction.id != props.ann.id,
    'animate-none': annStore.isEditing,
    [`${props.ann.animation} hover:scale-105 z-10 active:scale-[90%]`]: !isNoneClickAction.value,
  }
})

const doMouseEnter = () => {
  if (props.ann.do_spotlight) {
    annStore.startSpotlight(props.ann)
  }
}

const doMouseLeave = () => {
  annStore.endSpotlight()
}
</script>

<template>
  
  <div class="w-full h-full touch-manipulation" :style="styling.base" :data-id="ann.id" @mouseenter="doMouseEnter" @mouseleave="doMouseLeave">
    <img :src="cdnImageUrl(ann.transformed_content || ann.content)" :class="getImageClassList" class="w-full h-full object-contain"/>
    <!-- TOOD check size and show setting -->
    <div v-if="ann.show_caption && (ann.caption || ann.extra)" class="text-2xl text-center" :style="styling.caption" v-html="ann.transformed_caption || ann.caption || ann.extra">
    </div>
  </div>

</template>
